import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Download, Save } from '../../assets/icons';
// import { jsPDF } from 'jspdf';
import '../../assets/css/components/notes.css';

const Notes = ({ content, title }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [documentUrl, setDocumentUrl] = useState('');

    useEffect(() => {
        if (content) {
            if (content.includes('drive.google.com')) {
                const fileId = extractGoogleDriveFileId(content);
                if (fileId) {
                    // Convert to Google Drive preview link
                    const embedUrl = `https://drive.google.com/file/d/${fileId}/preview`;
                    setDocumentUrl(embedUrl);
                } else {
                    setError('Invalid Google Drive link');
                }
            } else {
                setDocumentUrl(content);
            }
            setIsLoading(false);
        }
    }, [content]);

    const extractGoogleDriveFileId = (url) => {
        const regex = /\/d\/([a-zA-Z0-9_-]+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    // const handleDownload = async () => {
    //     try {
    //         const fileId = extractGoogleDriveFileId(content);
    //         if (!fileId) throw new Error('Invalid file ID');
            
    //         const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
    //         window.open(downloadUrl, '_blank');
    //     } catch (error) {
    //         console.error('Download failed:', error);
    //         setError('Failed to download document');
    //     }
    // };

    const handleDownload = async () => {
        try {
            const response = await fetch(documentUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${title || 'course'}_notes.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error('Download failed:', error);
            setError('Failed to download document');
        }
    };

    const handleSaveNotes = async () => {
        try {
            setIsSaving(true);
            // Add your API call to save notes URL to user's saved documents
            await new Promise(resolve => setTimeout(resolve, 1000));
            setIsSaving(false);
        } catch (error) {
            console.error('Failed to save notes:', error);
            setIsSaving(false);
        }
    };

    if (isLoading) {
        return (
            <div className="notes-section">
                <div className="notes-loading">Loading document...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="notes-section">
                <div className="notes-error">{error}</div>
            </div>
        );
    }

    return (
        <div className="notes-section">
            <div className="notes-header">
                <h3>{title || 'Course Notes'}</h3>
                <div className="notes-tools">
                    <button 
                        className="tool-button" 
                        onClick={handleSaveNotes}
                        disabled={isSaving}
                    >
                        <img src={Save} alt="save" />
                        <span>{isSaving ? 'Saving...' : 'Save'}</span>
                    </button>
                    <button 
                        className="tool-button" 
                        onClick={handleDownload}
                    >
                        <img src={Download} alt="download" />
                        <span>Download</span>
                    </button>
                </div>
            </div>

            <div className="notes-content">
                <iframe
                    src={documentUrl}
                    title={title || 'Course Notes'}
                    className="notes-iframe"
                    frameBorder="0"
                    allowFullScreen
                    loading="lazy"
                />
            </div>
        </div>
    );
};

Notes.propTypes = {
    content: PropTypes.string,
    title: PropTypes.string
};

export default Notes;